import Link from "next/link";

export default function PortalUnavailable({ title = "This space is not available here." }) {
  return (
    <div className="grid min-h-[60svh] place-items-center px-4 py-12">
      <section className="max-w-md text-center">
        <h1 className="text-xl font-semibold text-[var(--fg-primary)]">{title}</h1>
        <p className="mt-2 text-sm text-[var(--muted)]">
          Return to the portal to browse the spaces available in this community.
        </p>
        <Link href="/" className="btn mt-5 inline-flex">Portal home</Link>
      </section>
    </div>
  );
}
